import { useMutation, useQueryClient } from '@tanstack/react-query';
import { usersService, type RegisterUserPayload } from '../../../services';

export function useRegisterUser() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (payload: RegisterUserPayload) => {
      const result = await usersService.registerUser(payload);

      if (!result.success) {
        throw new Error(result.error || 'Erro ao registrar usuário');
      }

      return result.data;
    },
    onSuccess: async () => {
      await queryClient.invalidateQueries({ queryKey: ['users'] });
    },
  });
}
